export { default } from './Dynamic'
